/* global location */
import { isSeoLocationRoute } from '../../utils/urlHelpers'
import { stripLocaleFromPath } from '../../utils/localeHelpers'

function showcasePageContextString (showcaseUrlPath) {
  return 'showcases'.concat('_', urlPathSeoSegments(showcaseUrlPath)[0])
}

// Break down Url paths and remove non SEO folder segments
// in /room-type/bedroom/furniture/seating/style/antique
// out ['furniture', 'seating', 'style', 'antique']
function urlPathSeoSegments (urlPath) {
  const strippedPath = stripLocaleFromPath(urlPath)
  const segments = strippedPath.split('/').slice(1)
  if (strippedPath.startsWith('/room-type')) {
    return segments.slice(2)
  } else if (strippedPath.startsWith('/showcases')) {
    return segments.slice(1)
  } else {
    return segments
  }
}

function userOnCategoriesPage () {
  return isSeoLocationRoute(location)
}

function userOnShowcasePage (urlPath) {
  return stripLocaleFromPath(urlPath).startsWith('/showcases')
}

function userOnRoomTypePage (urlPath) {
  return stripLocaleFromPath(urlPath).startsWith('/room-type')
}

function setShowcasePageContext () {
  if (userOnShowcasePage(location.pathname)) {
    return showcasePageContextString(location.pathname)
  }
}

function setModifierPageContext () {
  if (userOnCategoriesPage()) {
    return modifierContextString(location.pathname)
  }
}

function setRoomTypeContext () {
  if (userOnRoomTypePage(location.pathname)) {
    return roomTypeContextString(location.pathname)
  }
}

// Pin hits in the Algolia editor by checking for e.g. room_type_bedroom in Context
function roomTypeContextString (urlPath) {
  const strippedPath = stripLocaleFromPath(urlPath)
  const segments = strippedPath.split('/').slice(1)
  return `room_type_${segments[1]}`
}

function setSeoCategoryPageContext () {
  if (userOnCategoriesPage()) {
    return seoCategoryPageContext(location.pathname)
  } else {
    return []
  }
}

const modifiersList = [
  'brand',
  'colour',
  'designer',
  'material',
  'period',
  'style',
  'location',
  'door-type',
  'shape',
  'feature',
  'seating-shape',
  'orientation',
  'art-size',
  'art-subject',
  'artistic-movement',
  'set-of'
]

// true if currently handled URL segment or previous one is a recognised modifier (key)
function segmentPositionIsModifier (segments, segmentPosition) {
  return modifiersList.includes(segments[segmentPosition]) || modifiersList.includes(segments[segmentPosition - 1])
}

function segmentIsValid (segments, segmentPosition) {
  return segments[segmentPosition] !== undefined &&
    segments[segmentPosition] !== null &&
    !segmentPositionIsModifier(segments, segmentPosition)
}

function ruleContext (segments, position) {
  const ruleContextKeys = [
    'category_name',
    'subcategory_name',
    'product_type_name'
  ]

  return ruleContextKeys[position].concat('_', segments[position])
}

export function seoCategoryPageContext (catUrlPath) {
  const seoCategoryRuleContexts = []
  const seoSegments = urlPathSeoSegments(catUrlPath)

  for (let segmentPosition = 0; segmentPosition <= 2; segmentPosition++) {
    if (segmentIsValid(seoSegments, segmentPosition)) {
      seoCategoryRuleContexts.push(ruleContext(seoSegments, segmentPosition))
    }
  }

  return seoCategoryRuleContexts
}

const modifiersHash = {
  brand: 'brand_name',
  colour: 'color_name',
  designer: 'designed_by_name',
  material: 'main_material_name',
  period: 'year_of_manufacture',
  style: 'vibe_names',
  location: 'address_city',
  'door-type': 'door_type_name',
  shape: 'shape_name',
  feature: 'feature_names',
  'seating-shape': 'seating_shape_names',
  orientation: 'orientation_name',
  'art-size': 'art_size_name',
  'art-subject': 'art_subject_names',
  'artistic-movement': 'artistic_movement_names',
  'set-of': 'set_of'
}

function getAlgoliaModifierName (urlModifierName) {
  return modifiersHash[urlModifierName]
}

// Detect position of modifier in URL
// return ruleContext string based on that or null otherwise
export function modifierContextString (catUrlPath) {
  const segments = urlPathSeoSegments(catUrlPath)
  let indexOfReturnModifier = -1
  let returnModifier = ''

  modifiersList.forEach(modifier => {
    const indexOfModifier = segments.indexOf(modifier)
    if (indexOfModifier > -1) {
      returnModifier = modifier
      indexOfReturnModifier = indexOfModifier
    }
  })

  if (indexOfReturnModifier === -1) return null
  return getAlgoliaModifierName(returnModifier).concat('_', segments[indexOfReturnModifier + 1])
}

function setTagsContext () {
  const params = new URLSearchParams(location.search)
  if (userHasTagInUrl(params)) {
    return tagContextString(params)
  }
}

function userHasTagInUrl (params) {
  if (params.has('tR[0]')) {
    return true
  }
}

function tagContextString (params) {
  return 'tag'.concat('_', params.get('tR[0]'))
}

function cleanContextRulesArray (array) {
  return array.filter(element => (element !== null) && (element !== undefined))
}

// Suggestion for future -
// Liniar flow taking out first segments out of URL if e.g. /room-type/keyword
// taking out other segments if e.g. showcase
// take out modifier from URL if present and set in returning array
// process remaining as SEO only segments i.e. cat, subcat, prodType..
const contextRulesArray = [
  setShowcasePageContext(),
  ...setSeoCategoryPageContext(),
  setModifierPageContext(),
  setTagsContext(),
  setRoomTypeContext()
]

export const ruleContexts = cleanContextRulesArray(contextRulesArray)
